module.exports = __webpack_public_path__ + "img/m-logo.d485fbc6.png";